export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "totalJobCreations",
            label: "Total Job Creations",
            component: "cardbutton",
            valueKey: "value",
            percentageKey: "percentage",
            arrowDirectionKey: "arrowDirection",
            caption: "vs last week",
            borderColor: "var(--grape)",
          },
          {
            name: "totalExports",
            label: "Total Exports",
            component: "cardbutton",
            valueKey: "value",
            percentageKey: "percentage",
            arrowDirectionKey: "arrowDirection",
            caption: "vs last month",
            borderColor: "var(--pink)",
          },
          {
            name: "Tracking",
            label: "Tracking",
            component: "cardbutton",
            valueKey: "value",
            percentageKey: "percentage",
            arrowDirectionKey: "arrowDirection",
            caption: "vs last month",
            borderColor: "var(--blue)",
          },
          {
            name: "ActiveClients",
            label: "Active Clients",
            component: "cardbutton",
            valueKey: "value",
            percentageKey: "percentage",
            arrowDirectionKey: "arrowDirection",
            caption: "vs last week",
            borderColor: "var(--green-500)",
          },
        ],
      },
    },
  ],
};
